import { render, staticRenderFns } from "./fgv.vue?vue&type=template&id=27fe0136"
import script from "./fgv.vue?vue&type=script&lang=ts"
export * from "./fgv.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports